import { ShoppingCartEmptyPageHitV2 } from '@inditex/resellanl-ianalytics-events';
import { buildEvent } from '../helpers/build-event';
import { normalizeUniverse } from '../helpers/normalize-universe';

export const SHOPPING_CART_EMPTY_PAGE_HIT = ({ data }: { data?: unknown }) => {
  const payload = data as {
    cartId?: string | number | null;
    universe?: string | null;
    travelMode?: boolean | null;
    storeMode?: {
      geoStoreId?: number | null;
      physicalStoreId?: number | null;
    } | null;
  };

  return buildEvent({
    Event: ShoppingCartEmptyPageHitV2,
    payload: {
      cartId: payload?.cartId != null ? String(payload.cartId) : '',
      universe: normalizeUniverse(payload?.universe ?? undefined),
      travelMode: payload?.travelMode ?? null,
      storeMode: payload?.storeMode ?? null,
    },
  });
};
